import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "mf_cookie_consent_v1";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (!choice) {
      // Defer slightly so the banner doesn't interfere with hero animation
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (level) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ level, decided_at: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[60] bg-black border-t border-[#c0392b]"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      data-testid="cookie-banner"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 py-5 md:py-6 flex flex-col md:flex-row gap-5 md:items-center">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="text-[#c0392b] shrink-0 mt-1" size={22} />
          <p className="text-white text-sm md:text-[15px] leading-relaxed">
            Utilizamos cookies para melhorar a tua experiência e analisar o tráfego do site.{" "}
            <Link
              to="/politica-cookies"
              className="text-[#c0392b] hover:text-white underline underline-offset-4 transition-colors"
              data-testid="cookie-banner-policy-link"
            >
              Política de Cookies
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <button
            onClick={() => accept("essential")}
            className="cta-secondary text-xs px-6 py-3"
            data-testid="cookie-accept-essential"
          >
            Apenas Essenciais
          </button>
          <button
            onClick={() => accept("all")}
            className="cta-primary text-xs px-6 py-3"
            data-testid="cookie-accept-all"
          >
            Aceitar Todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
